/**
 * @generated SignedSource<<5033e53a60b3b9df1c8e929326db9db6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userName"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserMutationGroup",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "email",
                "variableName": "email"
              },
              {
                "kind": "Variable",
                "name": "userName",
                "variableName": "userName"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "UserModifyUserPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewUserModalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewUserModalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1c2beaf9366420ab26d7d257f3578bed",
    "id": null,
    "metadata": {},
    "name": "NewUserModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewUserModalMutation(\n  $userName: String!\n  $email: String!\n) {\n  user {\n    create(input: {email: $email, userName: $userName}) {\n      user {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "0e8aa321bee5745845dfa0ee6a9d9120";

export default node;
